<template>
  <v-dialog v-model="show" max-width="350px">
    <v-card v-if="!noRoom">
      <v-card-title class="headline font-weight-bold">
        Select the group
        <v-spacer></v-spacer>
        <v-btn color="grey lighten-1 darken-1 pr-0" icon @click="show = false">
          <v-icon class="pa-0" size="20px">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-radio-group v-model="radioGroup">
          <v-radio v-for="n in room" :key="n.id" :label="`${n.title}`" :value="n.id"></v-radio>
        </v-radio-group>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="white--text"
          :color="$buttonColor"
          flat
          @click="enroll"
          :disabled="radioGroup === -1"
        >Enroll</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="noRoom">
      <v-card-title class="headline font-weight-bold">
        Select the group
        <v-spacer></v-spacer>
        <v-btn color="grey lighten-1 darken-1 pr-0" icon @click="show = false">
          <v-icon class="pa-0" size="20px">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>Please contact admin to create the group first</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="white--text" :color="$buttonColor" flat @click="show=false">Ok</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { EventBus } from "@/event-bus";

export default {
  data: () => ({
    show: false,
    radioGroup: -1,
    room: [],
    noRoom: false
  }),
  beforeCreate() {
    //clear Eventbus's openDialog on beforecreate because beforeDestroy can't successfully finish before new instance(same instance) created and it's delete EventBus's of new instance.
    EventBus.$off("openEnrollDialog");
  },
  async mounted() {
    await this.fetchRoom();
    await EventBus.$on("openEnrollDialog", show => {
      console.log("enroll");
      if (this.room.length > 1) {
        this.openEnrollDialog(show);
      } else {
        EventBus.$emit("enroll", this.room[0].id);
      }
    });
  },
  computed: {
    courseId() {
      return this.$route.params.id;
    }
  },
  methods: {
    fetchRoom() {
      this.$http
        .get(
          `${this.$store.state.api}/room/list/course?idcourse=${this.courseId}`
        )
        .then(resp => {
          this.room = resp.data.result.map(r => {
            return { title: r.title, id: r._id };
          });
          this.noRoom = this.room.length === 0;
        })
        .catch(err => {})
        .finally(() => {
          this.progressEnroll = false;
        });
    },
    enroll() {
      EventBus.$emit("enroll", this.radioGroup);
      EventBus.$emit("openEnrollDialog", false);
    },
    openEnrollDialog(show) {
      this.show = show;
    }
  }
};
</script>
